<template>
  <!-- /**
* 作用于哪些页面
* 注明代码业务/功能说明
* @authors lynn
* @date 2020-06-11
* @version 2.0
  */-->
  <div id="app">
    <router-view :key="$route.name" v-if="isRouterAlive" />
  </div>
</template>
<script>
export default {
  name: 'home',
  components: {},
  // 使用reload刷新 在组件内 export default 下加入 inject: ['reload'],      使用 this.reload() 调用
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },

  // 声明reload方法，控制router-view的显示或隐藏，从而控制页面的再次加载
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  },
  created () {

  }
}
</script>
<style lang="scss">
@import "../src/styles/static-style";
</style>
